<template>
  <b-col :sm="12" :md="12" :lg="3">
    <b-form-group
        label="Vacina"
        label-for="vacina-input"
        label-class="font_size_label"
    >
      <v-select
          id="vacina-input"
          v-model="localValue"
          :options="vacinaSelect"
          label="nome_tecnico_vacina"
          placeholder="Selecione uma vacina"
          :clearable="true"
          :loading="loading"
          :disabled="disabled"
      >
        <span slot="no-options">Nenhuma opção selecionável.</span>
      </v-select>
    </b-form-group>

    <div class="mb-1 d-flex justify-content-end">
      <b-form-checkbox
          :disabled="disabled"
          v-model="localShowInativas"
          @change="onToggleInativas"
      >
        Exibir vacinas inativas
      </b-form-checkbox>
    </div>
  </b-col>
</template>

<script>
import {BCol, BFormGroup, BFormCheckbox} from 'bootstrap-vue';
import vSelect from 'vue-select';

export default {
  name: "InputVacina",

  components: {
    BCol,
    BFormGroup,
    BFormCheckbox,
    vSelect,
  },

  props: {
    value: {type: [Object, String], default: null},
    vacinaSelect: {type: Array, default: () => []},
    showInativas: {type: Boolean, default: false},
    loading: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
  },

  data() {
    return {
      localValue: this.value,
      localShowInativas: this.showInativas,
    };
  },

  watch: {
    value(val) {
      this.localValue = val;
    },
    showInativas(val) {
      this.localShowInativas = val;
    },
    localValue(val) {
      this.$emit("input", val);
    }
  },

  methods: {
    onToggleInativas(isChecked) {
      if (!isChecked && this.localValue && this.localValue.ativo === false) {
        this.localValue = null;
        this.$emit("input", null);
      }

      this.$emit("change-inativas", isChecked);
    }
  }
};
</script>
